import * as types from '../mutation-types';
import {unionState} from '../helpers';

const state = () => ({
	reservations: [],
});


const actions = {
	fetchPending({commit}, {restaurantId, branchId}) {
		return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/reservations/pending`).then(response => {
			commit(types.STORE_RESERVATIONS, response.data);

			return response.data;
		});
	},

	fetchAccepted({commit}, {restaurantId, branchId, date}) {
		return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/reservations/accepted`, {
			params: {
				date
			}
		}).then(response => {
			commit(types.STORE_RESERVATIONS, response.data);

			return response.data;
		});
	},

	update({commit}, {reservationId, restaurantId, branchId, date, from, to, number_of_people, table_id}) {
		return axios.put(`/api/restaurants/${restaurantId}/branches/${branchId}/reservations/${reservationId}`, {
			date, from, to, number_of_people, table_id
		}).then(response => {
			commit(types.STORE_ONE_RESERVATION, response.data);

			return response.data;
		});
	},

	delete({commit}, {restaurantId, branchId, reservationId}){
		return axios.delete(`/api/restaurants/${restaurantId}/branches/${branchId}/reservations/${reservationId}`).then(() => {
			commit(types.DELETE_ONE_RESERVATION, reservationId);
		});
	},

	accept({commit}, {restaurantId, branchId, reservationId, date, from, to, number_of_people, table_id}){
		return axios.post(`/api/restaurants/${restaurantId}/branches/${branchId}/reservations/${reservationId}/accept`, {
			date, from, to, number_of_people, table_id
		}).then(() => {
			commit(types.ACCEPT_RESERVATION, reservationId);
		});
	},

	reject({commit}, {restaurantId, branchId, reservationId}){
		return axios.post(`/api/restaurants/${restaurantId}/branches/${branchId}/reservations/${reservationId}/reject`).then(() => {
			commit(types.REJECT_RESERVATION, reservationId);
		});
	},

	create({commit}, {restaurantId, branchId, number_of_people, date, from, to, visitor_name, table_id}) {
		return axios.post(`/api/restaurants/${restaurantId}/branches/${branchId}/reservations/reserve`, {
			number_of_people,
			date,
			from,
			to,
			visitor_name,
			table_id,
		}).then(response => {
				return response.data;
		});
	},
};

const mutations = {
	[types.STORE_RESERVATIONS](state, reservations) {
		state.reservations = reservations;
	},

	[types.STORE_ONE_RESERVATION](state, reservation) {
	    state.reservations = unionState(state.reservations, [reservation]);
	},

	[types.DELETE_ONE_RESERVATION](state, id) {
	    state.reservations = state.reservations.filter(f => f.id != id);
	},

	[types.ACCEPT_RESERVATION](state, id) {
	    state.reservations.find(f => f.id == id).is_accepted = true;
	},

	[types.REJECT_RESERVATION](state, id) {
	    state.reservations.find(f => f.id == id).is_accepted = false;
	},
};

const getters = {
	getById: state => id => state.reservations.find(f => f.id == id),
	getAll: state => branchId => state.reservations.filter(n => n.branch_id === branchId),
	getAccepted: state => branchId => state.reservations.filter(n => n.branch_id === branchId && n.is_accepted),
	getPending: state => branchId => state.reservations.filter(n => n.branch_id === branchId && n.is_accepted == null),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};